import { Skeleton } from "@vega-core/components/shadcn/skeleton";

type Props = {
  count?: number;
};

export const NotificationCenterSkeleton = ({ count = 5 }: Props) => (
  <ul
    aria-busy="true"
    className="flex flex-col divide-y divide-border/primary"
    data-testid="notification-center-skeleton"
  >
    {Array.from({ length: count }, (_, index) => (
      <li className="flex items-start gap-3 px-4 py-3" key={index}>
        <Skeleton className="shrink-0 h-10 w-10 rounded-default" />
        <div className="flex-1 min-w-0 flex flex-col gap-2 pt-1">
          <Skeleton className="h-3 w-3/4" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-1/4 mt-1" />
        </div>
      </li>
    ))}
  </ul>
);
